export const PrenuvoLogo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="prenuvo logo"
    >
      <path
        d="M23 19.5545C23 19.801 22.8016 20 22.5573 20H2.44327C2.19838 20 2 19.8003 2 19.5545C2 19.308 2.19838 19.109 2.44327 19.109H9.50476H22.5573C22.8023 19.109 23 19.3087 23 19.5545ZM9.50476 19.109C5.36691 19.109 2 15.7197 2 11.5545C2 7.38922 5.36691 4 9.50476 4C13.6426 4 17.0095 7.38922 17.0095 11.5545C17.0095 15.7204 13.6426 19.109 9.50476 19.109ZM16.1237 11.5545C16.1237 7.88088 13.1542 4.89172 9.50476 4.89172C5.85534 4.89172 2.88585 7.88088 2.88585 11.5545C2.88585 15.2281 5.85534 18.2172 9.50476 18.2172C13.1542 18.2172 16.1237 15.2281 16.1237 11.5545Z"
        fill="#002B2B"
      />
      <path
        d="M9.50476 19.109H2.44327C2.19838 19.109 2 19.308 2 19.5545C2 19.8003 2.19838 20 2.44327 20H22.5573C22.8016 20 23 19.801 23 19.5545C23 19.3087 22.8023 19.109 22.5573 19.109H9.50476ZM9.50476 19.109C5.36691 19.109 2 15.7197 2 11.5545C2 7.38922 5.36691 4 9.50476 4C13.6426 4 17.0095 7.38922 17.0095 11.5545C17.0095 15.7204 13.6426 19.109 9.50476 19.109ZM16.1237 11.5545C16.1237 7.88088 13.1542 4.89172 9.50476 4.89172C5.85534 4.89172 2.88585 7.88088 2.88585 11.5545C2.88585 15.2281 5.85534 18.2172 9.50476 18.2172C13.1542 18.2172 16.1237 15.2281 16.1237 11.5545Z"
        stroke="#002222"
        strokeWidth="0.5"
      />
    </svg>
  );
};
